export enum CostDisplayType {
  BASE = 'base',
  REPLACEMENT = 'replacement',
}
